import useRootStore from './useRootStore';

export default function useHome() {
  const { homeStore } = useRootStore();
  return homeStore;
}
